import React from "react";
import { ToastContainer } from "react-toastify";

import GiftCardDetail from "./components/GiftCardDetail";

const GiftCardDetailApp = (props) => (
  <>
    <ToastContainer icon={false} />
    <GiftCardDetail {...props} />
  </>
);

export default GiftCardDetailApp;
